import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import palette from '../../lib/styles/palette';

const buttonStyle = css`
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: bold;
    padding: 0.25rem 1rem;
    color: white;
    outline: none;
    cursor: pointer;
    height: 1.5;

    background: ${palette.gray[8]};
    &:hover {
        background: ${palette.gray[6]};
    }

    &:disabled {
        background: ${palette.gray[3]};
        color: ${palette.gray[5]};
        cursor: not-allowed;
    }

    /* props로 넣어줄 수 있다. */
    ${(props) => 
        props.fullWidth &&
        css`
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
            width: 100%;
            font-size: 1.125rem;
        `}
    ${(props) => 
        props.cyan &&
        css`
            background: ${palette.cyan[5]};
            &:hover {
                background: ${palette.cyan[4]};
            }
        `}
`;

const StyledButton = styled.button`
    ${buttonStyle}
`;

const StyledLink = styled(Link)`
    ${buttonStyle}
`;

const FullScreen = styled.div`
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;

`;

const BackgroundBlock = styled.div`
    // width: 320px;
    background: white;
    padding: 3rem;
    border-radius: 4px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.125);
    h2 {
        margin-top: 0;
        margin-bottom: 2rem;
    }
    p {
        margin-bottom: 3rem;
    }
    // .buttons {
    //     display: flex;
    //     justify-content: flex-end;
    // }
`;

const ButtonBackToList = (props) => { // <Button cyan fullWidth>로그인</Button>
    //return <StyledButton {...props} />;
    return props.to ? (
        <FullScreen>
            <BackgroundBlock>
                <p>잘못된 요청입니다.</p>
                <StyledLink {...props} cyan={props.cyan ? 1 : 0} />
            </BackgroundBlock>
        </FullScreen>
    ) : (
        <FullScreen>
            <BackgroundBlock>
                <StyledButton {...props} />
            </BackgroundBlock>
        </FullScreen>
    )
};

export default ButtonBackToList;